import React, { useState, useEffect } from 'react';

function LocationManagement({ clientId, token }) {
    const [buildings, setBuildings] = useState([]);
    const [selectedBuilding, setSelectedBuilding] = useState(null);
    const [rooms, setRooms] = useState([]);
    const [selectedRoom, setSelectedRoom] = useState(null);
    const [locations, setLocations] = useState([]);
    const [selectedlocation, setSelectedlocation] = useState(null);
    const [newBuildingName, setNewBuildingName] = useState('');
    const [newRoomName, setNewRoomName] = useState('');
    const [newLocationName, setnewLocationName] = useState('');
    const [structure, setStructure] = useState([]);  

    useEffect(() => {
        if (clientId) {
            console.log('*** LM useEffect: if clientId');

            // When the client changes, reset the building, room, and location states
            setSelectedBuilding(null);  // Reset selected building
            setRooms([]);  // Reset rooms
            setLocations([]);  // Reset locations
            setStructure([]);  // Reset structure
            
            fetch(`/api/buildings/${clientId}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            })
                .then(res => res.json())
                .then(data => {
                    if (Array.isArray(data)) {
                        setBuildings(data);  // Ensure data is an array
                    } else {
                        console.error("Expected an array but received:", data);
                        setBuildings([]);
                    }
                })
                .catch(error => {
                    console.error("Error fetching buildings:", error);
                    setBuildings([]);  // Set empty array on error
                });
        }
    }, [clientId, token]);

    // Fetch rooms and locations when a building is selected
    useEffect(() => {
        if (selectedBuilding) {
            console.log('*** LM useEffect: if selectedBuilding');

            // Fetch the structure of the selected building (rooms and locations together)
            fetch(`/api/buildings/${selectedBuilding}/structure`, {
                headers: { 'Authorization': `Bearer ${token}` }
            })
                .then(res => res.json())
                .then(data => {
                    
                    console.log('Fetched data:', data);  // Log the fetched data to inspect room_name values

                    setStructure(data);  // Set structure as the combined rooms and locations data
                    
                    // Extract unique rooms from the structure
                    const uniqueRooms = [
                        ...new Map(
                            data
                                .filter(item => item.room_id && item.room_name)  // Ensure room_id and room_name exist
                                .map(item => [item.room_id, { room_id: item.room_id, room_name: item.room_name }])  // Map room_id to room object
                        ).values()
                    ];
                        
                    console.log('Extracted rooms:', uniqueRooms);  // Log the unique room names
                    setRooms(uniqueRooms);  // Set the rooms state

                    // Extract locations with location_id and location_name
                    const extractedLocations = data.map(item => ({
                        location_id: item.location_id,
                        room_id: item.room_id,
                        room_name: item.room_name,
                        location_name: item.location_name
                    }));

                    console.log('Extracted locations:', extractedLocations);  // Log the unique room names
                    setLocations(extractedLocations);  // Set the rooms state                          
                })
                .catch(console.error);
            setSelectedRoom(null);  // Reset room selection
            setSelectedlocation(null);  // Deactivate location selection
        }
    }, [selectedBuilding, token]);

    useEffect(() => {
        console.log('*** LM useEffect: if selectedRoom');
        
        // Fetch locations when a room is selected
        if (selectedRoom) {
            console.log(`Selected room: ${selectedRoom}`)
            fetch(`/api/locations/${selectedRoom}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            })
                .then(res => res.json())
                .then(setLocations) 
                .catch(console.error);
    
            // Fetch the structure of the selected building (rooms and locations together) to update the screen
            fetch(`/api/buildings/${selectedBuilding}/structure`, {
                headers: { 'Authorization': `Bearer ${token}` }
            })
                .then(res => res.json())
                .then(data => {
                    console.log('Fetched data:', data);  // Log the fetched data to inspect room_name values
                    setStructure(data);  // Set structure as the combined rooms and locations data            
                }) 
                .catch(console.error);  // Always include error handling for API calls
        }
    }, [selectedRoom, selectedBuilding, token]);  // Ensure both selectedRoom and selectedBuilding are in the dependency array

    const handleAddBuilding = () => {
        console.log('+++ LM const function: handleAddBuilding');

        // Sending a POST request to the '/api/buildings' endpoint
        fetch('/api/buildings', {
            method: 'POST',         // Method: POST, which is used to submit new data
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}` 
            },        // Content type indicates we're sending JSON
            // The body of the request: contains the building name and client ID
            body: JSON.stringify({ building_name: newBuildingName, client_id: clientId }),
        })
        // Handling the response from the server
        .then(res => res.json())    // Convert the response to JSON
        .then(newBuilding => {
            setBuildings([...buildings, newBuilding]);  // Add new building to the state
            setSelectedBuilding(newBuilding.building_id);  // Select the newly added building
            setRooms([]);  // Reset the room selection (no pre-selections)
            setSelectedRoom(null);  // Ensure no room is selected
            setSelectedlocation(null);  // Deactivate the location dialogue
            setNewBuildingName('');  // Clear the input field for building name
        })
        // Catch any errors that occur during the request
        .catch(console.error);
    };

    const handleAddRoom = () => {
        console.log('+++ LM const function: handleAddRoom');

        if (!newRoomName.trim()) {
            return alert("Room name cannot be empty.");
        }

        fetch('/api/rooms', {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}` 
            },
            body: JSON.stringify({ room_name: newRoomName, building_id: selectedBuilding }),
        })
        .then(res => res.json())
        .then(newRoom => {
            setRooms([...rooms, newRoom]);
            console.log('Will set selected room to: ', newRoom.room_id)
            setSelectedRoom(newRoom.room_id);
            setNewRoomName('');  // Clear the input field for building name
        })
        .catch(console.error);
    };

    const handleAddlocation = () => {
        console.log('+++ LM const function: handleAddlocation');

        if (!newLocationName.trim()) {
            return alert("Location name cannot be empty.");
        }

        console.log("Adding location:", newLocationName, "to room:", selectedRoom);

        fetch('/api/locations', {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}` 
            },
            body: JSON.stringify({ location_name: newLocationName, room_id: selectedRoom }),
        })
        .then(res => res.json())
        .then(newLocation => {
            console.log("New location added:", newLocation); 
            setnewLocationName('');

            // Refetch the list of locations for the current room after the new location is added
            return fetch(`/api/locations/${selectedRoom}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

        })
        .then(res => res.json())
        .then(data => {
            console.log("Updated locations list:", data);  // Debugging
            setLocations(data);  // Ensure we set the updated locations
        })
        .catch(error => console.error('Error adding location:', error));

        // To retrigger selectedRoom useEffect in order to reload the location structure list.
        setSelectedRoom(null);  
        setSelectedRoom(selectedRoom);

        // Fetch the structure of the selected building (rooms and locations together) to update the screen
        // Looks redundant but is needed for reasons I don't understand...
        fetch(`/api/buildings/${selectedBuilding}/structure`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
            .then(res => res.json())
            .then(data => {
                console.log('Fetched data:', data);  // Log the fetched data to inspect room_name values
                setStructure(data);  // Set structure as the combined rooms and locations data            
            }) 
            .catch(console.error);  // Always include error handling for API calls
    };

    return (
        <div>
            <h2>Manage Locations</h2>

            {/* Building Dropdown */}
            <div>
                <h3>Select or Add a Building</h3>
                <select value={selectedBuilding || ''} onChange={(e) => setSelectedBuilding(e.target.value)}>
                    <option value="">-- Select a Building --</option>
                    {Array.isArray(buildings) && buildings.map(building => (
                        <option key={building.building_id} value={building.building_id}>
                            {building.building_name}
                        </option>
                    ))}
                </select>
                <input
                    type="text"
                    placeholder="New Building Name"
                    value={newBuildingName}
                    onChange={(e) => setNewBuildingName(e.target.value)}
                />
                <button onClick={handleAddBuilding}>Add Building</button>
            </div>

            {/* Room Dropdown */}
            {selectedBuilding && (
                <div>
                    <h3>Select or Add a Room</h3>
                    <select onChange={(e) => setSelectedRoom(e.target.value)} value={selectedRoom || ''}>
                        <option value="">-- Select a Room --</option>
                        {rooms.map(room => (
                            <option key={room.room_id} value={room.room_id}>
                                {room.room_name || 'Unnamed Room'}  {/* Use room_name as the displayed value */}
                            </option>
                        ))}
                    </select>
                    <input
                        type="text"
                        placeholder="New Room Name"
                        value={newRoomName}
                        onChange={(e) => setNewRoomName(e.target.value)}
                    />
                    <button onClick={handleAddRoom}>Add Room</button>
                </div>
            )}

            {/* Location Dropdown */}
            {selectedRoom && selectedBuilding && (
                <div>
                    <h3>Add a Location</h3>
                    <input
                        type="text"
                        placeholder="New Location Name"
                        value={newLocationName}
                        onChange={(e) => setnewLocationName(e.target.value)}
                    />
                    <button onClick={handleAddlocation}>Add Location</button>
                </div>
            )}
            {/* Display the structure of the selected building */}
            {structure.length > 0 && (
                <div>
                    <h3>Building Structure</h3>
                    <table>
                        <thead>
                            <tr>
                                <th>Building</th>
                                <th>Room</th>
                                <th>Location</th>
                            </tr>
                        </thead>
                        <tbody>
                            {structure.map((row, index) => (
                                <tr key={`${row.room_id}-${row.location_id}-${index}`}>
                                    <td>{row.building_name}</td>
                                    <td>{row.room_name}</td>
                                    <td>{row.location_name}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default LocationManagement;